/**
 * Copyright (C) 2020, Merkur India.
 *
 * The program(s) herein may be used and/or copied only with
 * the written permission of Merkur India. or in accordance with
 * the terms and conditions stipulated in the agreement/contract
 * under which the program(s) have been supplied.
 *
 * $Id: SKGameDescriptorDTO.ts ,v 1.0 Exp $
 * Date Author Changes
 * 3 July 2020 Sujata Nethani Created
 *
 */
 
namespace DTO
{
    /**
     * Simple GameDescriptorDTO to describe the game
     */
    export class SKGameDescriptorDTO extends GameDescriptorDTO {

        constructor(){
            super();
            this._gameName = "adp_blazingstar";
			this._displayName = "Blazing Star";
        }

        public hasFreegame():boolean {
            return false;
        }
        public hasLineSelection():boolean{
            return false;
        }
        public hasScatterSymbols():boolean{
            return false;
        }
        public hasWildSymbols():boolean {
            return false;
        }

        getWinProbability():string{
			//Win Prob is same for all the RTPs
            return "83.333";
        }
        getMinimalGameRunDurationToReachAverageGameRunDuration(averageSpinDuration:number,minimalGameRunDuration:number):number{
            if(averageSpinDuration==5000){
                return 4400;
            }
            return minimalGameRunDuration;
        }
    }
}
